import request from '@/utils/request'

const baseApi = {
  getDictData: (params) => {
    return request({
      url: '/dictionary/get',
      method: 'get',
      params
    })
  },
  deleteFile: (data) => {
    return request({
      url: '/file/delete',
      method: 'post',
      data
    })
  },
  queryProvince: () => {
    return request({
      url: '/public/district/province/list',
      method: 'get'
    })
  },
  queryCity: (params) => {
    return request({
      url: '/public/district/city/list',
      method: 'get',
      params
    })
  },
  queryCounty: (params) => {
    return request({
      url: '/public/district/county/list',
      method: 'get',
      params
    })
  },
  queryAbibrand: () => {
    return request({
      url: '/abi/brand/query',
      method: 'get'
    })
  },
  queryAbibrandInfo: (brandId) => {
    return request({
      url: '/abi/brand/info/' + brandId,
      method: 'get'
    })
  },
  queryPocmAbibrand: () => {
    return request({
      url: '/public/pocm/brand/query',
      method: 'get'
    })
  },
  // 判断是否拥有冰萃卡券
  queryBrand: () => {
    return request({
      url: '/ecard/query/brand',
      method: 'get'
    })
  },
  // region列表
  getOrgList: () => {
    return request({
      url: '/public/org/vo-list',
      method: 'get'
    })
  }
}

export default baseApi
